import { FC } from 'react';
import type { Me, Person } from '../../types';
import { ObjectiveWithRef as Objective } from '../../utils/models/Objective';
import ObjectiveCollaborators from './ObjectiveCollaborators';

interface Props {
  objective: Objective;
  disabled?: boolean;
  isIndividual: boolean;
  onSave: (objective: Objective) => void;
  isRootObjective: boolean;
  profilePerson?: Person;
  me?: Me;
}

const ObjectiveCollaboratorsOrPlaceholder: FC<Props> = ({
  objective,
  disabled,
  isIndividual,
  onSave,
  isRootObjective,
  profilePerson,
  me,
}) => {
  return (
    <ObjectiveCollaborators
      objective={objective}
      disabled={disabled}
      minCollaborators={isIndividual ? 1 : 0}
      onSave={onSave}
      isRootObjective={isRootObjective}
      isIndividual={isIndividual}
      profilePerson={profilePerson}
      me={me}
    />
  );
};

export default ObjectiveCollaboratorsOrPlaceholder;
